import { render, staticRenderFns } from "./not-just-a-bowler.vue?vue&type=template&id=0b70625e&scoped=true&"
var script = {}
import style0 from "./not-just-a-bowler.vue?vue&type=style&index=0&id=0b70625e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b70625e",
  null
  
)

export default component.exports